export default __webpack_public_path__ + "static/media/farwest_vs_perky_texture.fc71ee27.jpg";